import { helpers } from "./theme/helpers.js";
import { datePicker } from "./theme/components/datePicker.js";
import { repertoirFilter } from "./theme/components/repertoirFilter.js";
import MobileMenu from "./theme/components/menuToggler.js";
import { gallery } from "./theme/components/gallery.js";
import { select2Init } from "./theme/components/select2Init.js";

window.theme = {
  globals: {
    isTouch: typeof window !== "undefined" && "ontouchstart" in window,
  },

  helpers: helpers,

  init: function () {
    var self = this;

    // Inicializace mobilního menu
    new MobileMenu();

    // Inicializace galerie s lightboxem
    gallery.init();

    // Inicializace Select2 pro filtry
    select2Init.init();

    // Block-now slider
    const blockNowSlider = document.querySelector('.block-now__slider');
    if (blockNowSlider) {
      tns({
        container: '.block-now__slider',
        items: 1,
        slideBy: 1,
        nav: true,
        controls: false,
        autoplay: true,
        autoplayButton: false,
        mouseDrag: true,
        loop: true,
      });
    }





jQuery(document).ready(function($) {

    let selectedCandleType = '';
    let personalData = {};

    // Načíst data typů svíček z kontejneru
    var $candleContainer = $('#candleFormContainer');
    var candleTypesData = $candleContainer.data('candle-types') || {};

    // Krok 1: Start - tlačítko "Vybrat svíčku"
    $('#btnStartCandle').on('click', function() {
        goToStep(2);
    });

    // Krok 2: Výběr typu svíčky - kliknutí na celý card
    $('.candle-type-card').on('click', function() {
        selectedCandleType = $(this).data('type');
        $('#candleType').val(selectedCandleType);

        // Aktualizovat náhledy svíček na krocích 3, 5 a 6
        updateCandlePreviews(selectedCandleType);

        // Přechod na krok 3
        goToStep(3);
    });
    
    // Krok 3: Odeslání osobních údajů
    $('#candlePersonalForm').on('submit', function(e) {
        e.preventDefault();

        const $formMessage = $('#formMessagePersonal');

        // Validace
        const fullName = $('#fullName').val().trim();
        const email = $('#email').val().trim();
        const country = $('#country').val();
        const gdprConsent = $('#gdprConsent').is(':checked');

        // Validace emailu (jednoduchá regex)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!fullName || !email || !country || !gdprConsent) {
            showMessage($formMessage, candlePosts.strings.validationError, 'error');
            return;
        }

        if (!emailRegex.test(email)) {
            showMessage($formMessage, candlePosts.strings.emailError || 'Zadejte platný e-mail.', 'error');
            return;
        }

        // Split jména na first_name a last_name (přes mezeru)
        const nameParts = fullName.split(' ');
        const firstName = nameParts[0] || '';
        const lastName = nameParts.slice(1).join(' ') || '';

        // Uložit data do paměti
        personalData = {
            first_name: firstName,
            last_name: lastName,
            email: email,
            country: country
        };

        // Přechod na krok 4 (zklidnění)
        goToStep(4);
    });
    
    // Krok 4: Tlačítko "Pokračovat" (po zklidnění)
    $('#btnContinueToPrayer').on('click', function() {
        goToStep(5);
    });

    // Tlačítka Zpět
    $('#btnBackToStep2').on('click', function() {
        goToStep(2);
    });

    $('#btnBackToStep3').on('click', function() {
        goToStep(3);
    });

    $('#btnBackToStep4').on('click', function() {
        goToStep(4);
    });

    // Krok 5: Odeslání modlitby a vytvoření svíčky
    $('#candlePrayerForm').on('submit', function(e) {
        e.preventDefault();
        
        const $submitBtn = $('#btnSubmitPrayer');
        const $formMessage = $('#formMessagePrayer');
        
        // Disable tlačítko a zobrazit loading
        $submitBtn.prop('disabled', true).text('Odesílám...');
        $formMessage.hide();
        
        // reCAPTCHA token, pak AJAX request - vytvoření svíčky
        getRecaptchaToken('candle', function(recaptchaToken) {
            $.ajax({
                url: candlePosts.ajaxUrl,
                type: 'POST',
                data: {
                    action: 'create_candle',
                    nonce: candlePosts.nonce,
                    recaptcha_token: recaptchaToken,
                    candle_type: selectedCandleType,
                    first_name: personalData.first_name,
                    last_name: personalData.last_name,
                    email: personalData.email,
                    country: personalData.country,
                    message: $('#message').val()
                },
                success: function(response) {
                    if (response.success) {
                        // Hned přidat svíčku do seznamu
                        addNewCandleToList();

                        // Přechod na krok 6 (zapálení)
                        goToStep(6);
                    } else {
                        showMessage($formMessage, response.data.message || candlePosts.strings.error, 'error');
                        $submitBtn.prop('disabled', false).text('Zapálit svíčku →');
                    }
                },
                error: function() {
                    showMessage($formMessage, candlePosts.strings.error, 'error');
                    $submitBtn.prop('disabled', false).text('Zapálit svíčku →');
                }
            });
        });
    });

    // reCAPTCHA v3 token (skript a klíč načítá Contact Form 7). Když reCAPTCHA není k dispozici
    // nebo selže, pošle prázdný token – server pak rozhodne podle toho, jestli je reCAPTCHA zapnutá.
    function getRecaptchaToken(action, callback) {
        var done = false;
        var finish = function(token) {
            if (done) return;
            done = true;
            callback(token || '');
        };

        if (typeof grecaptcha === 'undefined' || typeof wpcf7_recaptcha === 'undefined' || !wpcf7_recaptcha.sitekey) {
            finish('');
            return;
        }

        // Pojistka, aby formulář nezůstal viset, když Google neodpoví
        setTimeout(function() { finish(''); }, 10000);

        grecaptcha.ready(function() {
            try {
                grecaptcha.execute(wpcf7_recaptcha.sitekey, { action: action }).then(finish, function() { finish(''); });
            } catch (err) {
                finish('');
            }
        });
    }
    
    // Funkce pro přechod mezi kroky
    function goToStep(stepNumber) {
        $('.candle-form-step').removeClass('active');
        $(`.candle-form-step-${stepNumber}`).addClass('active');

        // Scroll na container (hlavní body scroll)
        const container = document.getElementById('candleFormContainer');
        if (container) {
           const top = container.getBoundingClientRect().top + window.scrollY;
           window.scrollTo({ top: top, behavior: 'instant' });
        }

        // Skrýt seznam svíček na krocích 4, 5 a 6
        if (stepNumber >= 4) {
            $('.candle-list-container').hide();
        } else {
            $('.candle-list-container').show();
        }

        // Overlay na krocích 2, 3, 4, 5, 6
        if ([2, 3, 4, 5, 6].includes(stepNumber)) {
            $('#candleFormContainer').addClass('has-overlay');
        } else {
            $('#candleFormContainer').removeClass('has-overlay');
        }

        // Zobrazit jméno v kroku 5
        if (stepNumber === 5 && personalData.first_name) {
            var fullName = personalData.first_name;
            if (personalData.last_name) {
                fullName += ' ' + personalData.last_name;
            }
            $('#displayName').text(fullName);
        }
    }

    // Srovnání výšky všech kroků
    function equalizeCandleStepHeights() {
        var $steps = $('.candle-form-step');
        if (!$steps.length) return;

        // Reset min-height
        $steps.css('minHeight', '');

        // Temporarily show hidden steps for measurement
        var $hidden = $steps.not('.active');
        $hidden.css({
            display: 'flex',
            visibility: 'hidden',
            position: 'absolute',
            width: '100%'
        });

        // Find max height
        var maxHeight = 0;
        $steps.each(function() {
            var h = $(this).outerHeight();
            if (h > maxHeight) maxHeight = h;
        });

        // Restore hidden steps
        $hidden.css({
            display: '',
            visibility: '',
            position: '',
            width: ''
        });

        // Apply min-height
        $steps.css('minHeight', maxHeight + 'px');
    }

    equalizeCandleStepHeights();

    var resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(equalizeCandleStepHeights, 250);
    });

    // Funkce pro zobrazení zprávy
    function showMessage($element, message, type) {
        $element
            .removeClass('success error')
            .addClass(type)
            .html(message)
            .fadeIn();
    }

    // Funkce pro aktualizaci náhledů svíček na krocích 3, 5 a 6
    function updateCandlePreviews(type) {
        var typeData = candleTypesData[type];
        if (typeData && typeData.image_unlit) {
            // Kroky 3, 5 - nezapálená svíčka
            $('#candlePreviewStep3, #candlePreviewStep5').attr('src', typeData.image_unlit);
            // Krok 6 - nezapálená (čeká na kliknutí)
            $('#candleImageStep6').attr('src', typeData.image_unlit).removeClass('candle-lit');
        }
    }

    // Krok 6: Kliknutí na svíčku - zapálení (jednorázové)
    $('#candleImageStep6').on('click', function() {
        var $candle = $(this);

        // Pokud už je zapálená, nic nedělat
        if ($candle.hasClass('candle-lit')) {
            return;
        }

        var typeData = candleTypesData[selectedCandleType];
        if (typeData && typeData.image_burning) {
            $candle.attr('src', typeData.image_burning);
            $candle.addClass('candle-lit');
        }
    });
    
    // Funkce pro přidání nové svíčky do seznamu
    function addNewCandleToList() {
        var $candleGrid = $('#candleGrid');

        if (!$candleGrid.length) {
            return; // Seznam není na stránce
        }

        var firstName = personalData.first_name;
        var lastName = personalData.last_name;
        var country = $('#country option[value="' + personalData.country + '"]').text();
        var candleType = selectedCandleType;

        // Získat obrázek z dat bloku
        var typeData = candleTypesData[candleType] || {};
        var imageUrl = typeData.image_burning || '';

        // Zobrazení: "Jméno P." nebo jen "Jméno" pokud není příjmení
        var displayName = lastName
            ? firstName + ' ' + lastName.charAt(0) + '.'
            : firstName;

        // Vytvořit HTML nové svíčky
        var imageHtml = imageUrl
            ? `<img src="${imageUrl}" alt="" class="candle-card-img">`
            : `<div class="candle-placeholder candle-${candleType}"></div>`;

        var newCandleHtml = `
            <div class="candle-card candle-state-new" style="display: none;">
                <div class="candle-card__image">
                    <div class="candle-visual candle-visual--${candleType}">
                        ${imageHtml}
                    </div>
                </div>
                <div class="candle-card__content">
                    <h3 class="candle-card__name">${displayName}</h3>
                    <p class="candle-card__country">${country}</p>
                </div>
            </div>
        `;

        // Odstranit "Momentálně nehoří žádné svíčky" pokud tam je
        $candleGrid.find('.candle-no-results').remove();

        // Přidat na začátek seznamu s animací
        $(newCandleHtml).prependTo($candleGrid).fadeIn(600);

        // Aktualizovat statistiky
        updateStatistics();
    }
    
    // Funkce pro aktualizaci statistik
    function updateStatistics() {
        var $statNumbers = $('.candle-stat-number');
        
        if ($statNumbers.length > 0) {
            var currentCount = parseInt($statNumbers.first().text()) || 0;
            $statNumbers.first().text(currentCount + 1);
        }
    }

});

// Akce filtrace
jQuery(document).ready(function($) {
	const $filterForm = $('#akce-filter-form');
	const $akceList = $('#akce-list');
	const $pagination = $('#akce-pagination');
	const $resetBtn = $('#filter-reset');

	if (!$filterForm.length) return;

	// Submit handler
	$filterForm.on('submit', function(e) {
		e.preventDefault();
		filterAkce(1); // Vždy resetovat na stránku 1
	});

	// Reset handler
	$resetBtn.on('click', function(e) {
		e.preventDefault();

		// Clear form
		$filterForm[0].reset();

		// Clear Select2 selections
		$('#filter-misto, #filter-stitek').val(null).trigger('change');

		// Clear URL
		updateURL({});

		// Filter with empty params
		filterAkce(1);
	});

	// Pagination click handler (delegated)
	$(document).on('click', '#akce-pagination a.page-numbers', function(e) {
		e.preventDefault();

		const href = $(this).attr('href');
		const pageMatch = href.match(/\/page\/(\d+)/);
		const page = pageMatch ? parseInt(pageMatch[1]) : 1;

		filterAkce(page);

		// Scroll to top of results
		$('html, body').animate({
			scrollTop: $filterForm.offset().top - 100
		}, 300);
	});

	// Main filter function
	function filterAkce(page = 1) {
		// Show loading state
		$akceList.css('opacity', '0.5');
		$pagination.css('opacity', '0.5');

		// Get form data
		const archivValue = $('#filter-archiv').val();
		const formData = {
			action: 'filter_akce',
			nonce: filterAkceVars.nonce,
			datum_od: $('#filter-datum-od').val(),
			datum_do: $('#filter-datum-do').val(),
			misto: $('#filter-misto').val(),
			stitek: $('#filter-stitek').val(),
			search: $('#filter-search').val(),
			archiv: archivValue,
			paged: page
		};

		// Update URL
		const urlParams = {};
		if (formData.datum_od) urlParams.datum_od = formData.datum_od;
		if (formData.datum_do) urlParams.datum_do = formData.datum_do;
		if (formData.misto) urlParams.misto = formData.misto;
		if (formData.stitek) urlParams.stitek = formData.stitek;
		if (formData.search) urlParams.search = formData.search;
		if (archivValue === '1') urlParams.archiv = '1';
		if (page > 1) urlParams.paged = page;

		updateURL(urlParams);

		// Ajax call
		theme.helpers.apiCall(formData)
			.then(response => {
				if (response.success) {
					// Update list
					$akceList.html(response.data.html);

					// Update pagination
					if (response.data.pagination) {
						$pagination.html(response.data.pagination);
					} else {
						$pagination.html('');
					}

					// Restore opacity
					$akceList.css('opacity', '1');
					$pagination.css('opacity', '1');
				} else {
					console.error('Filter error:', response.data.message);
					alert(response.data.message || 'Došlo k chybě při filtrování.');
					$akceList.css('opacity', '1');
					$pagination.css('opacity', '1');
				}
			})
			.catch(error => {
				console.error('Ajax error:', error);
				alert('Došlo k chybě při komunikaci se serverem.');
				$akceList.css('opacity', '1');
				$pagination.css('opacity', '1');
			});
	}

	// Update URL without reload
	function updateURL(params) {
		const url = new URL(window.location);

		// Clear existing params
		url.search = '';

		// Add new params
		Object.keys(params).forEach(key => {
			if (params[key]) {
				url.searchParams.set(key, params[key]);
			}
		});

		// Update URL
		window.history.pushState({}, '', url);
	}

	// Load from URL on page load
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.toString()) {
		// URL has params, form is already populated from PHP
		// No need to filter again
	}
});

  },
};

jQuery(document).ready(function ($) {
  theme.init();
});

// Candle Map (Leaflet)
jQuery(document).ready(function($) {
    var mapEl = document.getElementById('candleMap');
    if (!mapEl || typeof L === 'undefined') return;

    var markersData = JSON.parse(mapEl.dataset.markers || '[]');
    var pinImage = mapEl.dataset.pinImage || '';

    var map = L.map('candleMap', {
        scrollWheelZoom: false,
        zoomControl: true,
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 19,
    }).addTo(map);

    var bounds = L.latLngBounds();

    markersData.forEach(function(m) {
        var iconHtml = pinImage
            ? '<div class="candle-map-pin" style="background-image: url(' + pinImage + ')"><span class="candle-map-pin__count">' + m.count + '</span></div>'
            : '<div class="candle-map-pin candle-map-pin--default"><span class="candle-map-pin__count">' + m.count + '</span></div>';

        var icon = L.divIcon({
            html: iconHtml,
            className: 'candle-map-marker',
            iconSize: [48, 56],
            iconAnchor: [24, 56],
            popupAnchor: [0, -56],
        });

        var marker = L.marker([m.lat, m.lng], { icon: icon }).addTo(map);
        bounds.extend([m.lat, m.lng]);

        marker.bindPopup(
            '<div class="candle-map-popup">' +
                '<strong class="candle-map-popup__country">' + m.name + '</strong>' +
                '<span class="candle-map-popup__count">' + m.count + '</span>' +
            '</div>',
            { closeButton: false }
        );
    });

    // Auto-fit to markers or show whole world
    if (bounds.isValid()) {
        map.fitBounds(bounds, { padding: [40, 40], maxZoom: 6 });
    } else {
        map.setView([20, 0], 2);
    }
});
